module.exports = __webpack_public_path__ + "static/media/distillery-environ.e1cf92bd.png";